const muCarousel = () => {
    const $carousels = $("[mu-carousel]");
    const carousels = [];
    if ($carousels.length > 0) {
        $carousels.each((i, el) => {
            carousels.push(new MuCarouselInst($(el)));
        });
    }
};

class MuCarouselInst {
    _timer;
    _counter = 0;
    _startTime = new Date();
    _isPaused = false;
    constructor($el) {
        this._$carousel = $el;
        this._$items = $(".carousel-item", this._$carousel);
        if (this._$items.length > 1) {
            this._init();
            this.start();
        }
    }

    _init() {
        this._interval = this._$carousel.data("slide-interval");
        this._$progress = $(".carousel-item__progress", this._$carousel);
        this._$progressBar = $(".carousel-item__progress-bar", this._$carousel);
        this._$prev = $(".carousel-control-prev", this._$carousel);
        this._$next = $(".carousel-control-next", this._$carousel);
        this._$btns = $("a", this._$carousel);
        this._$pauseToggle = $('input[type="checkbox"]', this._$carousel);
        this.__onMouseMove = this._onMouseMove.bind(this);
        this._$carousel.carousel({ interval: false });       
        this._$carousel.on("slide.bs.carousel", (e) => {
            this._startTime = new Date().getTime();
            this._counter = 0;
        });
        this._$items.on("mouseenter", (e) => {
            this._onMouseEnter();
        });
        this._$items.on("mouseleave", (e) => {
            this._onMouseLeave();
        });
        this._$prev.on("click", (e) => {
            e.preventDefault();
            this.prev();
        });
        this._$next.on("click", (e) => {
            e.preventDefault();
            this.next();
        });
        this._$btns.on("focus", (e) => {
            this.stop();
        });
        this._$btns.on("blur", (e) => {
            this.start();
        });
        this._$pauseToggle.on("focus", (e) => {
            this.stop();
        });
        this._$pauseToggle.on("blur", (e) => {
            this.start();
        });
        this._$pauseToggle.on("change", (e) => {
            this._isPaused = $(e.target).is(":checked");
            if (this._isPaused) {
                this._$pauseToggle.prop("checked", true);
                this._$pauseToggle.attr("aria-checked", true);
                this.stop();
            } else {
                this._$pauseToggle.prop("checked", false);
                this._$pauseToggle.attr("aria-checked", true);
                this.start();
            }
        });
        this._$carousel.addClass("is-ready");
    }

    _onMouseEnter() {
        this.stop();
        window.addEventListener("mousemove", this.__onMouseMove, false);
    }

    _onMouseLeave() {
        window.removeEventListener("mousemove", this.__onMouseMove);
        this.start();
    }

    _onMouseMove() {
        this.stop();
    }

    start() {
        if (!this._isPaused) {
            this._$carousel.removeClass("is-paused");
            this._startTime = new Date().getTime() - this._counter;
            clearInterval(this._timer);
            this._timer = setInterval(() => this._update(), 5);
        }
    }

    stop() {
        this._$carousel.addClass("is-paused");
        clearInterval(this._timer);
    }

    prev() {
        clearInterval(this._timer);
        this._$carousel.carousel("prev");
        this.start();
    }

    next() {
        clearInterval(this._timer);
        this._$carousel.carousel("next");
        this._startTime = new Date().getTime();
        this._counter = 0;
        this._update();
        this.start();
    }

    _update() {
        if (this._counter >= this._interval) {
            this.next();
        }
        const now = new Date().getTime();
        this._counter = now - this._startTime;
        const percentage = (this._counter / this._interval) * 100;
        const width = (this._$progress.width() / 100) * percentage;
        this._$progressBar.css({ width: `${width}px` });
        this._$progressBar.attr('aria-valuenow', parseInt(percentage, 10));
        
    }
}

export default muCarousel;
